<template>
	<div class="register_pw">
				<v-header :goBackag='true' :register='true'></v-header>
				<span class="title" v-show="false">{{$t('emailproving.register')}}</span>
			<div class="pro_pic"  v-show="false">
				<img src="../../../static/img/dp-logo.jpg" alt=" "/>
			</div>
			<p style="margin-top: 20px;text-align:center;color: #7dc3f2;height: 2.6rem;line-height:2.6rem;">{{$t('login.setLoginPsw')}}</p>
			<div class="input_con">
				<div class="pos_icon">
					<div class="icon icon3"><img src="../../../static/img/login2/registeremail2.png" alt=""></div>
					<el-input
						:placeholder="$t('register.enterPsd')"
						v-model="password"
						class="password"
						:type='phonePsw'
						@change="passwordVerification"
						maxlength="16"
					>
					</el-input>
					<div class="eye" @click="eye('phonePsw')"><img src="../../../static/img/login2/registeremail3.png" alt=""></div>
				</div>
				<span class="danger" v-show="flag2">{{$t('changepassword.lessPsd')}}</span>
		        <p class="danger" v-show="flag10">{{$t('changepassword.notPsd')}}</p>
				<div class="pos_icon">
					<div class="icon icon3"><img src="../../../static/img/login2/registeremail2.png" alt=""></div>
					<el-input
						:placeholder="$t('register.againEnterPsd')"
						v-model="repassword"
						class="repassword"
						:type='pswAgain'
						@change="repasswordVerification"
						maxlength="16"
						>
					</el-input>
					<div class="eye" @click="eye('pswAgain')"><img src="../../../static/img/login2/registeremail3.png" alt=""></div>
				</div>
				<span class="danger" v-show="flag3">{{$t('changepassword.notSamePsd')}}</span>
			</div>
			<br />
			<div class="overdiv">
				<el-button type="danger" class="over" @click='finish()'>{{$t('mynewsedit.finish')}}</el-button>
			</div>
	</div>
</template>

<script>
import store from "../../store/store.js";
import { userLogin,registerByMobile } from "../../api/index.js";
import Qs from "qs";
import axios from "axios";
import header from '../../components/header';
export default{
	name:"registerpassword",
	data(){
		return{
			phonenumber:"",
			smsCode:"",
			areaCode:"",
			password: "",
      		repassword: "",	
      		flag2: false,
      		flag3: false,
			flag10: false,
			phonePsw:'password',
			pswAgain:'password'
		}
	},
	mounted() {
		this.phonenumber=this.$route.query.phone
		this.smsCode=this.$route.query.smsCode
		this.areaCode=this.$route.query.areaCode
	    if (sessionStorage.getItem("time")) {
	    	let count1 = sessionStorage.getItem("time");
	    	this.timer = setInterval(() => {
		        count1--;
		        this.msg = this.$t('forgetpassword.resend') + count1 + "S";
		        this.forbidden = true;
		        this.count = count1;
		        sessionStorage.setItem("time", count1);
		        if (this.count == 0) {
		          this.msg = this.$t('forgetpassword.verify');
		          this.count = 60;
		          clearInterval(this.timer);
		          this.forbidden = false;
		          sessionStorage.removeItem("time", count1);
				}
			}, 1000);
		}
	},
	components:{
        "v-header":header
    },
	methods: {
		eye(type){
			switch (type){
				case 'phonePsw':
				if(this.phonePsw=='password'){
					this.phonePsw = 'text'
				}else{
					this.phonePsw = 'password'
				}
				break;
				case 'pswAgain':
				if(this.pswAgain=='password'){
					this.pswAgain = 'text'
				}else{
					this.pswAgain = 'password'
				}
				break;

			}
		},
	passwordVerification() {
		this.password = this.password.trim()
		if(this.password.length < 6 && this.password.length > 0) {
			this.flag2 = true;
		} else {
			this.flag2 = false;
		}
		if(this.flag1 == true && this.password.length == 0) {
			this.flag10 = true;
		} else {
			this.flag10 = false;
		}
		if(
			(this.flag1 == true && this.repassword.length == 0) || this.flag1 == true &&
			this.password != this.repassword
		) {
			this.flag3 = true;
		} else {
			this.flag3 = false;
		}
	},
	repasswordVerification() {
		if(this.repassword != this.password && this.repassword.length != 0) {
			this.flag3 = true;
		} else {
			this.flag3 = false;
		}
	},
	
	finish() {
		if(this.password.length == 0) {
			this.flag10 = true;
		} else {
			this.flag10 = false;
		}
		if(
			(this.repassword.length == 0) ||
			this.password != this.repassword
		) {
			this.flag3 = true;
		} else {
			this.flag3 = false;
		}
		if(
			this.flag10 == false &&
			this.flag3 == false
		) {
			var params = Qs.stringify({
				mobile: this.phonenumber,
				password: this.password,
				smsCode: this.smsCode
			});
			registerByMobile(params)
				.then(res => {
					if(res.data.header.status==1000){
					// console.log(res.data);
					//成功后跳转页面
					var params = Qs.stringify({
						areaCode:this.areaCode,
						username: this.phonenumber,
						password: this.password
					});
					userLogin(params)
					.then(res => {
						sessionStorage.setItem("login", "1");
						this.$store.commit("set_token", res.headers["x-auth-token"]);
						this.$router.push({
			                name: "login",
			                query: {
			                  accessToken: localStorage.token,
			                  deviceCode: localStorage.codeId
			                }
		              	});
//						if(res.data.data.isFirst==false){
//							this.$router.push({
//								path: "/myAccount"
//							});
//						}else{
//							this.$router.push({
//								path: "/mynewsedit"
//							});
//						}
					})
					.catch(error => {
						console.log(error);
					});
					}
					if(res.data.header.status==3045){
						this.$alert(this.$t('login.pswSimple'))
					}
				})
				.catch(error => {
					console.log(error);
				});
			}
		}
	}
}
</script>
<style>
.register_pw .el-input input{
	border: 0;
	border-bottom: 1px solid #cccccc;
	border-radius: 0;
	box-sizing: border-box;
	padding-left: 2.5rem;
}
</style>

<style scoped>
	/*头部*/
	.title{
		text-align: center;
		font-size: .75rem;
		display: block;
		color: #828282;
	}
	.logo{
		text-align: center;
		width: 50%;
		margin: 0 auto;
		margin-top: 8px;
	}
	.logo img{
		width: 100%;
	}
	.pro_pic{
		width: 90%;
		margin: 1rem auto;
		text-align: center;
	}
	/*输入密码*/
	.input_con{
		width: 90%;
		margin: 0 auto;
	}
	.pos_icon{
		position: relative;
		width: 100%;
		height: 2.6rem;
		line-height: 2.6rem;
		margin-top: 20px;
	}
	.icon{
		position: absolute;
		z-index: 99;
		width: 2rem;
		height: 1.5rem;
		line-height: 1.5rem;
		border-right: 1px solid #cccccc;
		top: 0.5rem;
	}
	.icon img{
		width: 1rem;
		vertical-align: middle;
	}
	.eye{
		position: absolute;
		right: 0.5rem;
		top: 0.2rem;
	}
	.eye img{
		width: 1.2rem;
	}

	.el-container{
		width: 100%;
	}
	.danger{
		font-size: 0.625rem;
		margin-top: 5px;
		color: red;
	} 
	.overdiv{
		width: 72%;
		margin: 0 auto;
	}
	.over{
		width: 100%;
		font-size: 1rem;
		height: 2.6rem;
		line-height: 2.6rem;
		color: rgb(255,255,255);
		margin-top: 30px;
		border-radius: 1.3rem;
		background-color: transparent;
		background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
		border: 0;
		padding: 0 0;
	}
</style>


// WEBPACK FOOTER //
// src/m_page/login/registerpassword.vue